import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import formatDate from "../../util/dateFormat";
import { formatDate1, getEncodedValue } from "../forms/utility";
import { APIConstants } from "../../constants/ApiConstants";
import { useAppSelector } from "../../redux/hooks";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import theme from "../../theme";
import useButtonStyles from "../../styles/useButtonStyles";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { debounce } from "../../util/debounce";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InfiniteTable from "../Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../../Hooks/CustomHooks/UseGetTotalRecords";
import {
  SearchToolTip,
  filterConstants,
  DateConstants,
  permissionsConstants,
} from "../../constants/AppConstants";
import SearchInput from "../../Shared/Components/SearchInput/SearchInput";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
interface TableColumn {
  key: string;

  header: string;

  searchable?: boolean;

  filterable?: boolean;
}
const columns: TableColumn[] = [
  { key: "itemImage", header: "Image" },
  { key: "itemName", header: "Title" },
  { key: "itemPrice", header: "Selling Price" },
  { key: "totalQuantity", header: "Total Quantity" },
  { key: "availableQuantity", header: "Available Quantity" },
  { key: "soldQuantity", header: "Sold Quantity" },
  { key: "fromDate", header: "From Date" },
  { key: "toDate", header: "To Date" },
  { key: "activationDate", header: "Activation Date" },
  { key: "flashStatus", header: "Status" },
];
const metaData = {
  itemImage: {
    isImage: true,
    linkTo: "",
  },
  itemName: {
    isImage: false,
    linkTo: "",
  },
  itemPrice: {
    isImage: false,
    linkTo: "",
  },
  totalQuantity: {
    isImage: false,
    linkTo: "",
  },
  soldQuantity: {
    isImage: false,
    linkTo: "",
  },
  fromDate: {
    isImage: false,
    linkTo: "",
  },
  toDate: {
    isImage: false,
    linkTo: "",
  },
  activationDate: {
    isImage: false,
    linkTo: "",
  },
  flashStatus: {
    isImage: false,
    linkTo: "",
  },
};

const FlashSalesAllNew = () => {
  const { getUserPermission: allFlashSalesPermissions } = usePermissionGetter(
    permissionsConstants.flash_sale,
    permissionsConstants.all_flash_sales
  );
  const buttonStyles = useButtonStyles();
  const [flashSalesData, setFlashSales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [activiationDate, setActivationDate] = useState("");
  const [filterActive, setFilterActive] = useState(false);
  const [isResetApiCall, setIsResetApiCall] = useState(false);
  const [filterStatus, setFilterStatus] = useState(filterConstants.All);
  const searchInputRef = useRef<HTMLInputElement>();
  const { selectedMerchatDetails } = useAppSelector(
    (state: any) => state.persistReducers.getMerchantList
  );
  const { totalCount, getTotalCounts } = useGetTotalRecords();
  const { merchantId } = selectedMerchatDetails;

  const handleClose = () => {
    setOpenFilter(false);
  };
  const handleChange = (event: SelectChangeEvent) => {
    setFilterStatus(event.target.value as string);
  };
  const resetFields = () => {
    setFilterStatus(filterConstants.All);
    setFromDate("");
    setToDate("");
    setActivationDate("");
    setFilterActive(false);
    setIsResetApiCall(true);
  };

  useEffect(() => {
    if (isResetApiCall) getFlashSales();
  }, [isResetApiCall]);

  const getFlashSales = async (searchValue?: string) => {
    let newSearchValue = encodeURIComponent(searchValue ? searchValue : "");
    try {
      setLoading(true);
      let url =
        process.env.REACT_APP_API_URL +
        APIConstants.getMerchantDeals +
        `?filter=flashsales&MerchantID=${merchantId}${
          newSearchValue ? `&QuerySearch=${newSearchValue}` : ""
        }${fromDate ? `&ValidityStartDate=${fromDate}` : ""}${
          toDate ? `&ValidityEndDate=${toDate}` : ""
        }${activiationDate ? `&ActivationDate=${activiationDate}` : ""}${
          filterStatus && filterStatus !== filterConstants.All
            ? `&Status=${filterStatus}`
            : ""
        }`;
      if (flashSalesData.length === 0)
        getTotalCounts(url, "data.Result.data.flashsales");
      const deals = await axios.get(url);
      const data = deals.data.Result.data.flashsales;
      const mappedData = data.map((sales: any) => ({
        itemImage: sales.ProductImage ? sales.ProductImage : "-",
        itemName: sales.ProductName ? sales.ProductName : "-",
        itemPrice: sales.Price ? sales.Price : "-",
        totalQuantity: sales.TotalQTY ? sales.TotalQTY : "-",
        availableQuantity: sales.AvailableQty ? sales.AvailableQty : "-",
        soldQuantity: sales.SoldQty ? sales.SoldQty : "-",
        fromDate: sales.SalesStartDate ? formatDate(sales.SalesStartDate) : "-",
        toDate: sales.SalesExpiryDate ? formatDate(sales.SalesExpiryDate) : "-",
        activationDate: sales.ActivationDateTime
          ? formatDate1(sales.ActivationDateTime)
          : "-",
        flashStatus: sales.ActivatedOrNot ? sales.ActivatedOrNot : "-",
        // flashStatus: sales.ActivatedOrNot
        //   ? sales.ActivatedOrNot === "1"
        //     ? "Online"
        //     : "Offline"
        //   : "-",
      }));
      setFlashSales(mappedData);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
      setIsResetApiCall(false);
    }
    if (activiationDate || toDate || fromDate || filterStatus) {
      setFilterActive(true);
    }
  };

  const getSearchFlashSaleDebounce = useCallback(
    debounce(getFlashSales, 1000),
    []
  );

  useEffect(() => {
    getFlashSales();
  }, []);

  const handleSearch = () => {
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    setFlashSales([]);
    getFlashSales(searchValue);
  };

  return (
    <Grid>
      <Grid display={"flex"} justifyContent={"end"} px={4} gap={2} py={4}>
        <SearchInput
          HelpTip={SearchToolTip.Sales}
          onCallBack={handleSearch}
          ref={searchInputRef}
        />
        {allFlashSalesPermissions("read") && (
          <Button
            variant="text"
            startIcon={
              filterActive ? (
                <FilterAltIcon sx={{ color: theme.color?.secondary }} />
              ) : (
                <FilterAltOutlinedIcon />
              )
            }
            sx={{
              color: theme.color?.newFilterGrey,
              textTransform: "capitalize",
            }}
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            Filter
          </Button>
        )}

        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "483px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              <IconButton onClick={() => setOpenFilter(false)}>
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid borderBottom={theme.border?.newGreyBorder} py={4}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  From Date
                </Typography>
                <Grid display={"flex"} mt={2} gap={2} width={"70%"}>
                  <TextField
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    type="date"
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  ></TextField>
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.newGreyBorder} py={4}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  To Date
                </Typography>
                <Grid display={"flex"} mt={2} gap={2} width={"70%"}>
                  <TextField
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    type="date"
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  ></TextField>
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.newGreyBorder} py={4}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Activation Date
                </Typography>
                <Grid display={"flex"} mt={2} gap={2} width={"70%"}>
                  <TextField
                    value={activiationDate}
                    onChange={(e) => setActivationDate(e.target.value)}
                    type="date"
                    size="small"
                    fullWidth
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  ></TextField>
                </Grid>
              </Grid>
              <Grid
                mb={2}
                pt={4}
                display={"flex"}
                flexDirection={"column"}
                gap={2}
              >
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Status
                </Typography>
                <Grid width={"70%"}>
                  <Select
                    value={filterStatus}
                    label=""
                    onChange={handleChange}
                    fullWidth
                    size="small"
                    defaultValue={filterConstants.All}
                  >
                    <MenuItem value={filterConstants.All}>All</MenuItem>
                    <MenuItem value={filterConstants.Active}>Active</MenuItem>
                    <MenuItem value={filterConstants.Inactive}>
                      Inactive{" "}
                    </MenuItem>
                  </Select>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 3 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={resetFields}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={() => {
                  setFlashSales([]);
                  getFlashSales();
                  setOpenFilter(false);
                }}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
      </Grid>
      {allFlashSalesPermissions("read") && (
        <InfiniteTable
          header={columns}
          contentItems={flashSalesData}
          metaData={metaData}
          hasMoreRecords={false}
          isInitialLoading={flashSalesData.length === 0 && loading}
          totalRecords={totalCount}
        />
      )}
    </Grid>
  );
};

export default FlashSalesAllNew;
